module.exports = __webpack_public_path__ + "assets/img/mecha-btn-9aa5e103.png";